import React from "react";
import {
    IFreePlayVoucherViewModel
} from "../../../../services/free-play/vouchers/free-play-voucher-view-model.interface";
import {VoucherCardBox} from "../../boxes/voucher-card/voucher-card.box";
import {VoucherCardFaceComponent} from "./face/voucher-card-face.component";
import {observer} from "mobx-react";
import {OrbitComponentWithState} from "../../../base-components/orbit-component-with-state/orbit-component-with-state";
import {VoucherCardBackComponent} from "./back/voucher-card-back.component";
import {CyClass} from "../../../../../common/cy-classes";


interface VoucherCardComponentProps {
    voucher: IFreePlayVoucherViewModel;
    onClick?: (voucher: IFreePlayVoucherViewModel) => void;
}

interface VoucherCardComponentState {
    showBackSide: boolean;
}

@observer
export class VoucherCardComponent extends OrbitComponentWithState<VoucherCardComponentProps, VoucherCardComponentState> {
    constructor(props: VoucherCardComponentProps) {
        super(props);
        this.state = {
            showBackSide: false
        }
    }
    private _onToggleSide = () => {
        this.setState({
            showBackSide: !this.state.showBackSide
        });
    }

    private _onCardSideClickHandler = () => {
        if (this.props.onClick) {
            this.props.onClick(this.props.voucher);
        }
    }

    render() {
        return (
            <VoucherCardBox showCursor={Boolean(this.props.onClick)} className={CyClass('cy-free-play-voucher-container')}>
                <VoucherCardFaceComponent backgroundImageUrl={this.props.voucher.backgroundImageUrl} voucher={this.props.voucher} backSideShown={this.state.showBackSide} onToggleSide={this._onToggleSide} onClick={this._onCardSideClickHandler} />
                <VoucherCardBackComponent backgroundImageUrl={this.props.voucher.backgroundImageUrl} voucher={this.props.voucher} backSideShown={this.state.showBackSide} onToggleSide={this._onToggleSide} onClick={this._onCardSideClickHandler} />
            </VoucherCardBox>
        )
    }
}